import React, { useEffect, useMemo } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchInvestigationMaster } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { getInvestigationlist } from "../../../redux/action/investigation_action";

const DepartmentInvestigationDropdown = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
  rowData,
  disabled = false,
}) => {
  const dispatch = useDispatch();
  const selectedInvestigationId = watch("investigation_id");
  const login = useSelector((state) => state.jwtAuthreducer);

  const labDepartmentId =
    getValues()?.lab_department_id ||
    rowData?.lab_department_obj?.id ||
    rowData?.lab_department_id ||
    0;

  const payload = labDepartmentId
    ? { lab_department_id: labDepartmentId, ...login }
    : { ...login };
  const investigationName =
    rowData?.investigation_obj?.investigation_name ||
    rowData?.investigation_name ||
    getValues().investigation_name;

  const investigationId =
    rowData?.investigation_obj?.id ||
    rowData?.investigation_id ||
    getValues().investigation_id;

  const {
    data: Investigations,
    isLoading,
    refetch,
    error,
  } = useQuery(
    ["Investigation", labDepartmentId],
    () => fetchInvestigationMaster(payload),
    {
      // enabled: labDepartmentId > 0,
      staleTime: DROPDOWN_STALE_TIME,
    }
  );

  useEffect(() => {
    if (labDepartmentId > 0) {
      refetch();
    }
  }, [labDepartmentId, login]);

  const options = useMemo(
    () =>
      Investigations?.data?.data?.map((investigation) => ({
        value: investigation.id,
        label: investigation.investigation_name,
      })) || [],
    [Investigations?.data?.data]
  );

  const selectedOption = useMemo(() => {
    return (
      options.find((option) => option.value === selectedInvestigationId) ||
      options.find((option) => option.value === investigationId) ||
      options.find((option) => option.label === investigationName) ||
      null
    );
  }, [options, selectedInvestigationId, investigationId, investigationName]);

  useEffect(() => {
    if (rowData && options.length) {
      const rowDataOption = options.find(
        (option) =>
          option.value === rowData?.investigation_obj?.id ||
          option.value === rowData?.investigation_id
      );
      if (rowDataOption) {
        setValue("investigation_id", rowDataOption.value);
        setValue("investigation_name", rowDataOption.label);
      }
    }
  }, [rowData, options, setValue]);

  useEffect(() => {
    if (selectedOption) {
      setValue("investigation_id", selectedOption.value);
      setValue("investigation_name", selectedOption.label);
    } else {
      setValue("investigation_id", null);
      setValue("investigation_name", "");
    }
  }, [selectedOption, setValue]);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading Investigation Data</div>;

  return (
    <Controller
      name="investigation_name"
      control={control}
      rules={{ required: "Investigation Name is required" }}
      render={({ field }) => (
        <Select
          {...field}
          isDisabled={disabled}
          options={options}
          isClearable
          value={selectedOption}
          placeholder="Select Investigation Name"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          onChange={(selectedOption) => {
            const value = selectedOption ? selectedOption.value : "";
            field.onChange(value);
            setValue("investigation_id", value);
            setValue(
              "investigation_name",
              selectedOption ? selectedOption.label : ""
            );
            dispatch(getInvestigationlist(value));
          }}
          className={`react-select-container ${
            errors.investigation_id ? "is-invalid" : ""
          }`}
        />
      )}
    />
  );
};

export default DepartmentInvestigationDropdown;
